import React from 'react'
import FormSelect from 'components/forms/bases/FormSelect'

const TextTransformSelector = ({
  value,
  onChange,
}) => {
  return (
    <FormSelect
      label="Text Transform"
      value={value || 'initial'}
      onChange={onChange}
      options={
        [
          { label: 'initial', value: 'initial' },
          { label: 'Capitalize', value: 'capitalize' },
          { label: 'lowercase', value: 'lowercase' },
          { label: 'UPPERCASE', value: 'uppercase' }
        ]
      }
    />
  )
}

TextTransformSelector.propTypes = {}
TextTransformSelector.defaultProps = {}

export default TextTransformSelector



// WEBPACK FOOTER //
// ./src/components/forms/TextTransformSelector.js